/* eslint-disable no-use-before-define */
import React from 'react'
import SearchForm from './search-form'
import RecentSearches from './recent-searches'
import SavedSearches from './saved-searches'
import KnowledgeCenter from './knowledge-center'
import {trackPage, show} from '../twd'

export default ({view, searchParams}) => {
    trackPage('advanced-screener')

    return (
    <React.Fragment>

    <div className="container">
    <div className="row vertical-offset-xs">
    <div className="col-md-9 col-xs-12">
        <h2 className="large-header">Advanced Screener</h2>
    </div>
    <div className="col-md-3 col-xs-12 text-right">
        <button
            data-name="advanced-screener-sell-your-bond-link"
            className="btn btn-link"
            onClick={() => show('sell-your-bond', {from: "advanced-screener"})}
            >Sell your bond</button>
    </div>
    </div>
    </div>

    <div style={{backgroundColor:"#f6f6f6"}}>
    <div className="container">
    <div className="row vertical-offset-lg">

        <div className="col-md-8 col-xs-12">
            <SearchForm searchParams={searchParams} invType={view.split('.')[1]} />
        </div>

        <div className="col-md-4 col-xs-12">
            <RecentSearches dataName="advanced-screener-recent-searches" />
            <SavedSearches dataName="advanced-screener-saved-searches" />
            <KnowledgeCenter dataName="advanced-screener-knowledge-center" />
        </div>
    </div>
    </div>
    </div>
    </React.Fragment>)
}



// WEBPACK FOOTER //
// ./src/advanced-screener/advanced-screener.js